<style src="./ColumnItem.scss" lang="scss" scoped></style>
<template>
  <li
    :class="{ notquoted: !(info.quoted.proposalPrice > 0) }"
    class="analysis-column-item box"
  >
    <div class="id">
      <span v-if="!!info.quoted.lot" class="labellot">{{
        info.quoted.itemLot
      }}</span>
      <span class="labelitem">{{ info.quoted.itemNumber }}</span>
      <div
        class="detail"
        v-if="info.quoted.strictToME || info.quoted.isPriceGuaranted"
      >
        <span
          v-if="info.quoted.strictToME"
          class="strict-to-me stricttome"
          title="Exclusivo para Micro Empresa"
        >
          ME
        </span>

        <div
          v-if="info.quoted.isPriceGuaranted"
          class="symbol guaranted"
          title="Item com garantia de preço"
        >
          <icon-star class="icon" />
        </div>
      </div>
    </div>

    <div class="product">
      <div class="eventinfo">
        <span class="alternatecode badge">{{
          info.event.alternativeCode
        }}</span>
        <span class="client">{{ info.event.client }}</span>
      </div>
      <div class="eventinfo">
        <span class="date badge">{{ info.event.date | DateBR }}</span>
        <span class="identification badge">{{
          info.event.identification
        }}</span>
      </div>
      <span class="description">
        {{ info.quoted.description }}
      </span>
      <div class="fulldescription">{{ info.quoted.description }}</div>

      <div class="count">
        <span class="label" title="Quantidade">{{
          info.quoted.quantity | DecimalNumber
        }}</span>
        <span class="label" title="Fator"
          ><small>x</small> {{ info.quoted.factor | DecimalNumber }}</span
        >
        <span class="label cost" title="Custo cotado"
          ><small>R$</small> {{ info.quoted.cost | CurrencyBR }}</span
        >
        <span class="label unity" :title="`Unidade: ${info.quoted.unity}`">{{
          info.quoted.unity
        }}</span>
      </div>
    </div>

    <div class="proposal">
      <span class="title">PROPOSTA</span>
      <span class="price">
        <small class="prefix">R$ </small>
        {{ info.quoted.proposalPrice | CurrencyBR }}
        <small class="suffix"> {{ calculateProposalPerc(info) }}%</small>
      </span>
      <div class="extra minimum">
        <span class="label">MÍN</span>
        <span class="value"
          ><small>R$</small> {{ info.quoted.minimumPrice | CurrencyBR }}</span
        >
        <span class="perc">{{ calculateMinimumPerc(info) }}%</span>
      </div>
      <span class="lab" title="Marca da proposta">
        {{ info.quoted.lab }}
      </span>

      <template v-if="info.quoted.estimatedPrice">
        <div class="extra estimated">
          <span class="label">EST</span>
          <span class="value"
            ><small>R$</small>
            {{ info.quoted.estimatedPrice | CurrencyBR }}</span
          >
        </div>
      </template>
    </div>
  </li>
</template>

<script>
import {
  DecimalNumber,
  CurrencyBR,
  DateBR
} from "@/components/primitives/helpers/filters";
import { IconStar, IconLockGliph } from "@/components/primitives/icons";

export default {
  name: "ColumnItem",
  components: {
    IconStar,
    IconLockGliph
  },
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  filters: {
    DecimalNumber,
    CurrencyBR,
    DateBR
  },
  methods: {
    calculateProposalPerc(info) {
      const v1 = info.quoted.proposalPrice;
      const v2 = info.quoted.quotePrice;

      const r = (v1 * 100) / v2 - 100;
      return !isNaN(r) ? r.toFixed() : "";
    },
    calculateMinimumPerc(info) {
      const v1 = info.quoted.minimumPrice;
      const v2 = info.quoted.quotePrice;

      const r = (v1 * 100) / v2 - 100;
      return !isNaN(r) ? r.toFixed() : "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/item-analysis/components/column-item/ColumnItem.vue